var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60736 8.48832C7.25153 7.84064 4.74847 7.84064 2.39264 8.48832C0.979141 8.87552 0 10.1216 0 11.5366V13.1558C0 13.6698 0.434356 14.0922 0.971779 14.0922H11.0282C11.5656 14.0922 12 13.6698 12 13.1558V11.5366C12 10.1216 11.0209 8.87552 9.60736 8.48832Z",
    fill: "grey"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00026 6.67356C7.65671 6.67356 9.00394 5.3782 9.00394 3.78716C9.00394 2.19612 7.65671 0.900757 6.00026 0.900757C4.34382 0.900757 2.99658 2.19612 2.99658 3.78716C2.99658 5.3782 4.33646 6.67356 6.00026 6.67356Z",
    fill: "grey"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonDisable);
export default __webpack_public_path__ + "static/media/personDisable.47e350d1a236a4e40477efc5471f413e.svg";
export { ForwardRef as ReactComponent };